/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountdangerbody2Inputs */

const en_accountdangerbody2 = /** @type {(inputs: Accountdangerbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pauses your account immediately. We'll then permanently remove all your data within 30 days. Once paused, sign-in is blocked. To undo within those 30 days, email support.`)
};

const pt_accountdangerbody2 = /** @type {(inputs: Accountdangerbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suspende a conta imediatamente. Removeremos os seus dados permanentemente em até 30 dias. Após a suspensão, o acesso fica bloqueado. Para reverter dentro deste prazo, contacte o suporte.`)
};

/**
* | output |
* | --- |
* | "Pauses your account immediately. We'll then permanently remove all your data within 30 days. Once paused, sign-in is blocked. To undo within those 30 days, e..." |
*
* @param {Accountdangerbody2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const accountdangerbody2 = /** @type {((inputs?: Accountdangerbody2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountdangerbody2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_accountdangerbody2(inputs)
	return pt_accountdangerbody2(inputs)
});
export { accountdangerbody2 as "accountDangerBody" }